import React from "react";
import Modal, { ModalProps } from "components/Modal/Modal";
import {
  ModalBody,
  ResponsiveSanityImage,
  ResponsiveSanityImageProps,
  SanityImageRatio
} from "@silversea-ssc/ui-components-react";

export interface ItineraryMapModalProps extends ModalProps {
  map: ResponsiveSanityImageProps["image"];
}

const ItineraryMapModal: React.FC<ItineraryMapModalProps> = ({
  modal,
  map
}) => {
  return (
    <Modal
      title={""}
      modal={modal}
      size="big"
      data-content-name={`modal_itinerary_map`}
    >
      <ModalBody variant="full" paddingBottom>
        <SanityImageRatio ratio="auto" image={map}>
          <ResponsiveSanityImage
            image={map}
            fit="original"
            defaultWidth={1024}
            defaultHeight={600}
          />
        </SanityImageRatio>
      </ModalBody>
    </Modal>
  );
};

export default ItineraryMapModal;
